import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { H3 } from '@jetbrains/ring-ui/components/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import { getProfileConstituents } from '@common/store/profiles/selectors';
import { ProfileActions } from '@common/store/profiles/profile-reducer';
import { EnableJunieBanner } from './enable-junie-banner';
import styles from './ai-tools.css';
export function AiTools({ defaultProviders }) {
    const dispatch = useDispatch();
    const { ai } = useSelector(getProfileConstituents);
    const handleJunieChange = useCallback((isJunieEnabled) => dispatch(ProfileActions.updateAiConstituent({ isJunieEnabled })), [dispatch]);
    return (_jsxs("div", { className: styles.container, children: [_jsx(H3, { children: "AI Tools" }), _jsx("div", { className: styles.settingsForm, children: _jsx(EnableJunieBanner, { isJunieEnabled: ai.isJunieEnabled, onChange: handleJunieChange, defaultProviders: defaultProviders }) })] }));
}
